import http from '../../plugins/axios';

export default {

    queryCouponInfo(data){
        return http.get({
            url: '/admin/coupon/list',
            data
        })
    },

    addCoupon(data){
        return http.post({
            url: '/admin/coupon/add',
            data,
            dataType:'form'
        })
    },

    updateCoupon(data){
        return http.post({
            url: '/admin/coupon/update',
            data,
            dataType:'form'
        })
    },

    showCoupon(data){
        return http.post({
            url: '/admin/coupon/show',
            data,
            dataType:'form'
        })
    },

    startCoupon(data){
        return http.post({
            url: '/admin/coupon/start',
            data,
            dataType:'form'
        })
    },

    stopCoupon(data){
        return http.post({
            url: '/admin/coupon/stop',
            data,
            dataType:'form'
        })
    },

    getCouponRedeem(data){
        return http.get({
            url: '/admin/coupon/getRedeem',
            data
        })
    },

    stopRedeem(data){
        return http.post({
            url: '/admin/coupon/redeem/stop',
            data,
            dataType: 'form',
        })
    },

    removeCoupon(data){
        return http.post({
            url: '/admin/coupon/remove',
            data,
            dataType: 'form',
        })
    }

}
